import { Card, Flex } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";

import { SlideIdType } from "../../constants";
import { swiperAtom } from "../../store";
import {
  SlideBalance,
  SlideButton,
  SlideTelegram,
  SlideExporter,
} from "./components";
import css from "./SliderCard.module.scss";

interface SliderCardProps {
  cardId: SlideIdType;
}

export const SliderCard = ({ cardId }: SliderCardProps) => {
  const [swiperRef] = useAtom(swiperAtom);

  const slideComponents = {
    [SlideIdType["EXPORTER"]]: SlideExporter,
    [SlideIdType["TELEGRAM"]]: SlideTelegram,
    [SlideIdType["BALANCE"]]: SlideBalance,
  };

  const SlideCard = slideComponents[cardId] || SlideExporter;

  return (
    <Card view="clear" className={css.sliderCardContainer}>
      <Flex
        height={"100%"}
        direction={"column"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Flex
          gap={4}
          direction={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          width={"100%"}
        >
          <SlideCard activeIndex={swiperRef?.activeIndex || 0} />
        </Flex>
        <Flex justifyContent={"center"}>
          <SlideButton
            cardId={cardId}
            activeIndex={swiperRef?.activeIndex || 0}
          />
        </Flex>
      </Flex>
    </Card>
  );
};
